import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IResponseOption } from "@interfaces";

import type { IPathBaseParam } from "./path";
import type { IWarehouseKindsEnum } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IResponseOption<IWarehouseKindsEnum>>>,
  IPathBaseParam,
  IPaginationParams
>("selectTypes.warehouseKinds");

export const warehouseKinds = {
  ...getAllApis,
};
